import _ from 'lodash'

import { fhir2form, form2fhir } from '../Date/Format/index.js'

import { phoneMapping, otherMapping } from './lib/phone.js'
import { transform } from './mapper.js'

// still needs when adopted, date married, supportiveEmployer

const AccountIdentifier = {
  use: 'official',
  type: {
    coding: [
      {
        system: 'http://hl7.org/fhir/ValueSet/identifier-type',
        code: 'PRN'
      }
    ]
  }
}

const SSN_IDENTIFIER = {
  use: 'usual',
  type: {
    coding: [
      {
        system: 'http://hl7.org/fhir/v2/0203',
        code: 'SS'
      }
    ]
  },
  system: 'http://hl7.org/fhir/sid/us-ssn'
}

const COGNITO_IDENTIFIER = {
  system: 'https://aws.amazon.com/cognito/'
}

const MEMBER_ID = {
  system: 'http://narushealth.com/fhir/member-id'
}

const residenceTypeExt = {
  url: 'http://hl7.org/fhir/ValueSet/v3-LivingArrangement',
  valueCodeableConcept: {
    coding: [{ system: 'http://hl7.org/fhir/v3/LivingArrangement' }]
  }
}

const raceExt = {
  url: 'http://hl7.org/fhir/StructureDefinition/us-core-race',
  valueCodeableConcept: {
    coding: [{ system: 'http://hl7.org/fhir/v3/Race' }]
  }
}

const ethnicityEx = {
  url: 'http://hl7.org/fhir/StructureDefinition/us-core-ethnicity',
  valueCodeableConcept: {
    coding: [{ system: 'http://hl7.org/fhir/v3/Ethnicity' }]
  }
}

const declinedMobileEx = {
  url: 'http://narushealth.com/fhir/declinedMobileEnrollment'
}

const religiousPreferenceExt = {
  url: 'http://hl7.org/fhir/StructureDefinition/us-core-religion',
  valueCodeableConcept: {
    coding: [{ system: 'http://hl7.org/fhir/v3/ReligiousAffiliation' }]
  }
}

const educationLevelEx = {
  url: 'http://hl7.org/fhir/v3/EducationLevel',
  valueCodeableConcept: {
    coding: [{ system: 'http://hl7.org/fhir/v3/EducationLevel' }]
  }
}

const adoptionEx = {
  url: 'http://hl7.org/fhir/StructureDefinition/patient-adoptionInfo'
}
const whenAdoptionEx = {
  url: 'http://narus.com/when-adopted'
}

const occupationEx = {
  url: 'http://hl7.org/fhir/ValueSet/anzsco-occupations'
}

const accuityEx = {
  url: 'http://narushealth.com/fhir/patient-accuity'
}

const healthProgramEx = {
  url: 'http://narushealth.com/fhir/health-program'
}

const primaryConcernEx = {
  url: 'http://narushealth.com/fhir/primary-concern'
}

const notesEx = {
  url: 'http://narushealth.com/fhir/patient-notes'
}

const clientDivisionEx = {
  url: 'http://narushealth.com/fhir/patient-client-division'
}

const serviceEx = {
  url: 'http://narushealth.com/fhir/patient-service'
}

const phonesBatchEx = {
  url: 'http://narus.com/fhir/extensions/phones-batch'
}

const phonesDateEx = {
  url: 'http://narus.com/fhir/extensions/phones-date'
}

const EmployerContact = {
  organization: {},
  relationship: [
    {
      coding: [
        {
          code: 'e',
          display: 'Employer',
          system: 'http://hl7.org/fhir/v2/0131'
        }
      ],
      text: 'Employer / School'
    }
  ]
}

const dateMarriedEx = {
  url: 'http://narus.com/fhir/date-married'
}

const CommunicationLang = {
  language: { coding: [{ system: 'urn:ietf:bcp:47' }] },
  preferred: true
}

const emailMapping = [
  {
    fhir: [ 'value' ],
    form: [ 'address' ]
  },
  {
    fhir: [ 'rank' ],
    form: [ 'preferred' ],
    to_fhir: f => (f ? 1 : 2),
    to_form: f => f === 1
  }
]

const writtenConsent = {
  url: 'http://narushealth.com/fhir/patient-written-consent'
}

const doNotCallEx = {
  url: 'http://narushealth.com/fhir/patient-do-not-call'
}

const vipPatientEx = {
  url: 'http://narushealth.com/fhir/patient-vip'
}

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'Patient'
  },
  {
    fhir: [ 'active' ],
    fhir_const: true
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  {
    fhir: [ 'name', { use: 'official' }, 'family', 0 ],
    form: [ 'lastName' ]
  },
  {
    fhir: [ 'name', { use: 'official' }, 'given', 0 ],
    form: [ 'firstName' ]
  },
  {
    fhir: [ 'name', { use: 'official' }, 'given', 1 ],
    form: [ 'middleName' ]
  },
  {
    fhir: [ 'name', { use: 'official' }, 'suffix', 0 ],
    form: [ 'suffix' ]
  },
  {
    fhir: [ 'name', { use: 'usual' }, 'given', 0 ],
    form: [ 'preferredName' ]
  },
  {
    fhir: [ 'identifier', AccountIdentifier, 'value' ],
    form: [ 'accountId' ]
  },
  {
    fhir: [ 'identifier', SSN_IDENTIFIER, 'value' ],
    form: [ 'SSN' ]
  },
  {
    fhir: [ 'identifier', COGNITO_IDENTIFIER, 'value' ],
    form: [ 'cognitoUserId' ]
  },
  {
    fhir: [ 'identifier', MEMBER_ID, 'value' ],
    form: [ 'memberId' ]
  },
  {
    fhir: [ 'birthDate' ],
    form: [ 'dob' ],
    to_fhir: form2fhir,
    to_form: fhir2form
  },
  {
    fhir: [ 'gender' ],
    form: [ 'gender' ]
  },
  {
    fhir: [ 'maritalStatus' ],
    to_fhir: ms => ({
      text: ms,
      coding: [
        {
          system: 'http://hl7.org/fhir/v3/MaritalStatus',
          code: ms
        }
      ]
    }),
    form: [ 'maritalStatus' ],
    to_form: cc => _.get(cc, 'coding[0].code')
  },
  {
    fhir: [ 'address', { use: 'home' }, 'line', 0 ],
    form: [ 'address1' ]
  },
  {
    fhir: [ 'address', { use: 'home' }, 'line', 1 ],
    form: [ 'address2' ]
  },
  {
    fhir: [ 'address', { use: 'home' }, 'city' ],
    form: [ 'city' ]
  },
  {
    fhir: [ 'address', { use: 'home' }, 'postalCode' ],
    form: [ 'zip' ]
  },
  {
    fhir: [ 'address', { use: 'home' }, 'district' ],
    form: [ 'county' ]
  },
  {
    fhir: [ 'address', { use: 'home' }, 'state' ],
    form: [ 'usState' ]
  },
  {
    fhir: [
      'extension',
      residenceTypeExt,
      'valueCodeableConcept',
      'coding',
      0,
      'code'
    ],
    form: [ 'residenceType' ]
  },
  {
    fhir: [ 'extension', raceExt, 'valueCodeableConcept', 'coding', 0, 'code' ],
    form: [ 'race' ]
  },
  {
    fhir: [
      'extension',
      ethnicityEx,
      'valueCodeableConcept',
      'coding',
      0,
      'code'
    ],
    form: [ 'ethnicity' ]
  },
  {
    fhir: [
      'extension',
      religiousPreferenceExt,
      'valueCodeableConcept',
      'coding',
      0,
      'code'
    ],
    form: [ 'religiousPreference' ]
  },
  {
    fhir: [
      'extension',
      educationLevelEx,
      'valueCodeableConcept',
      'coding',
      0,
      'code'
    ],
    form: [ 'educationLevel' ]
  },
  {
    fhir: [ 'extension', adoptionEx, 'valueString' ],
    form: [ 'adopted' ]
  },
  {
    fhir: [ 'extension', whenAdoptionEx, 'valueDate' ],
    form: [ 'whenAdopted' ],
    to_fhir: form2fhir,
    to_form: fhir2form
  },
  {
    fhir: [ 'extension', occupationEx, 'valueString' ],
    form: [ 'occupation' ]
  },
  {
    fhir: [ 'extension', declinedMobileEx, 'valueBoolean' ],
    form: [ 'declinedMobileEnrollment' ]
  },
  {
    fhir: [ 'extension', accuityEx, 'valueString' ],
    form: [ 'par' ],
    to_fhir: par => par && String(par),
    to_form: par => par && (parseInt(par, 10) || par)
  },
  {
    fhir: [ 'extension', healthProgramEx, 'valueString' ],
    form: [ 'healthProgram' ]
  },
  {
    fhir: [ 'extension', primaryConcernEx, 'valueString' ],
    form: [ 'primaryConcern' ]
  },
  {
    fhir: [ 'contact', EmployerContact, 'organization', 'display' ],
    form: [ 'employer' ]
  },
  {
    fhir: [ 'communication', CommunicationLang, 'language', 'coding', 0, 'code' ],
    form: [ 'preferredLanguage' ]
  },
  {
    fhir: [ 'extension', dateMarriedEx, 'valueDate' ],
    form: [ 'dateMarried' ],
    to_fhir: form2fhir,
    to_form: fhir2form
  },
  {
    fhir: [ '_clientName' ],
    form: [ 'clientName' ]
  },
  {
    fhir: [ 'extension', notesEx, 'valueString' ],
    form: [ 'notes' ]
  },
  phoneMapping(),
  otherMapping(),
  {
    $mapping: emailMapping,
    fhir: [
      'telecom',
      {
        $filter: { system: 'email' },
        $collection: true
      }
    ],
    form: [ 'emails', { $collection: true }]
  },
  {
    fhir: [ 'extension', writtenConsent, 'valueBoolean' ],
    form: [ 'writtenConsent' ]
  },
  {
    fhir: [ 'extension', doNotCallEx, 'valueBoolean' ],
    form: [ 'doNotCall' ]
  },
  {
    fhir: [ 'extension', vipPatientEx, 'valueBoolean' ],
    form: [ 'isVIPPatient' ]
  },
  {
    fhir: [ 'deceasedDateTime' ],
    form: [ 'deceasedDateTime' ]
  },
  {
    fhir: [ 'specPercentage' ],
    form: [ 'specPercentage' ]
  },
  {
    fhir: [ 'extension', clientDivisionEx, 'valueString' ],
    form: [ 'clientDivision' ]
  },
  {
    fhir: [ 'extension', serviceEx, 'valueString' ],
    form: [ 'service' ]
  },
  {
    fhir: [ 'extension', phonesBatchEx, 'valueString' ],
    form: [ 'phonesBatch' ]
  },
  {
    fhir: [ 'extension', phonesDateEx, 'valueDate' ],
    form: [ 'phonesDate' ]
  },
  {
    fhir: [ 'managingOrganization', 'reference' ],
    to_fhir: o => o && `Organization/${o}-client`,
    form: [ 'clientName' ],
    to_form: o => o && (o.match(/^Organization\/(.+)-client$/) || [])[1]
  }
]

export function mapFormToPatient (data) {
  return transform(data, mapping, [ 'form', 'fhir' ])
}

export function mapPatientToForm (data) {
  return transform(data, mapping, [ 'fhir', 'form' ])
}

export default {
  mapFormToPatient,
  mapPatientToForm
}
